import React, {useState, useEffect} from "react";
import {useParams} from "react-router-dom";
import {useBoolean} from "@fluentui/react-hooks";

import ContainerLargeForm from "../../../components/containers/largeForm/containerLargeForm.component";
import {RequestFetch} from "../../../utils/Requests/requests.Controller";
import {CLIENT_FORM, OPTIONAL_FIELDS} from "./constants";
import {validateEmptyFields} from "../../../utils/validations/forms";

const PanelClient = (props) => {
  const {
    clientSelected,
    onClosePanel,
    optionsList,
    controlsPage
  } = props;

  const {clientName} = useParams();
  const [fieldsForm, setFieldsForm] = useState([]);
  const [formValues, setFormValues] = useState();
  const [isEdited, {
    setTrue: handleEdited
  }] = useBoolean(false);

  const RequestClient = new RequestFetch("Client");

  useEffect( () => {
    buildFields();
  }, []);

  function getDefaultValues() {
   return {
    //  idCaptcha: clientSelected?.idCaptcha || null,
     path: clientSelected?.path || null,
     clientLanguages: clientSelected?.clientLanguages?.[0]?.idLanguage || null,
     dynamicKeyLength: clientSelected?.dynamicKeyLength || null,
     dailyPasswordLimit: clientSelected?.dailyPasswordLimit || null,
     dynamicKeyDuration: clientSelected?.dynamicKeyDuration || null,
     idDynamicKeyType: clientSelected?.idDynamicKeyType || null,
     supportEmail: clientSelected?.supportEmail || null
    //  ,
    //  useVirtualKeyboard: clientSelected?.useVirtualKeyboard || null,
    //  useApp: clientSelected?.useApp || null,
    //  validateUpperLowerCase: clientSelected?.validateUpperLowerCase || null
   }
  }

  function getValuesStored() {
    const fieldKeys = [
      'path', 'clientLanguages', 'dynamicKeyLength', 'dynamicKeyDuration', 'dailyPasswordLimit',
      'idDynamicKeyType', 'supportEmail'
      // , 'useVirtualKeyboard', 'useApp',
      // 'validateUpperLowerCase'
    ];
    return fieldKeys.reduce((acc, key) => {
      const field = fieldsForm.find(f => f.key === key);
      acc[key] = field?.defaultValu ?? field?.defaultValue ?? null;
      return acc;
    }, {});
  }

  const buildFields = () => {
    const fieldOptions = {
      // idCaptcha: optionsList.captcha,
      clientLanguages: optionsList.languages,
      idDynamicKeyType: optionsList.dynamicKeys
    }
    let defaultValues;
    if (clientSelected && fieldsForm !== undefined && fieldsForm !== null && fieldsForm.length > 0) {
      defaultValues = getValuesStored()
      // console.log(defaultValues)
      // setFormValues(defaultValues)
    }else {
      defaultValues = getDefaultValues();
      // setFormValues(defaultValues);      
    }
    setFormValues((prev) => {
      if (JSON.stringify(prev) !== JSON.stringify(defaultValues)) {
        return defaultValues;
      }
      return prev;
    });
    const form = CLIENT_FORM.map(field => {
      let mappedField = field;
      if (fieldOptions[field.key]) {
        mappedField = {
          ...mappedField,
          options: fieldOptions[field.key]
        }
      }
      if (defaultValues?.[field.key] && clientSelected) {
        mappedField = {
          ...mappedField,
          disable: field.key === "path" ? true : undefined,
          defaultValu: defaultValues[field.key],
          defaultValue: defaultValues[field.key]
        }
      }
      return mappedField;
    })
    setFieldsForm((prev) => {
      if (JSON.stringify(prev) !== JSON.stringify(form)) {
        return form;
      }
      return prev;
    });
    // setFieldsForm(form);
  }

  const submitForm = async () => {
    if (validateEmptyFields(formValues, OPTIONAL_FIELDS)) {
      let payload = {
        ...formValues,
        supportEmail: formValues.supportEmail || "",
        clientLanguages: [{ idLanguage: formValues.clientLanguages}]
      }
      if(clientSelected){
        methodRequests.updateItem(payload, clientSelected.id, clientName);
        handleEdited();
      } else {
        await methodRequests.createItem(payload, clientName);
        onClosePanel(true);
      }
    }
  }


  const methodRequests = {
    createItem: async (payload, tenant) => {
      await RequestClient.createItem({body: payload, ct: "json", tenant, 
        infoModal:{
          title:controlsPage?.lblSuccessfulProcess?.value,
          description:controlsPage?.lblTheInformationHBeenRegisteredCorrectly?.value
          },
          op:"b"});
    },
    updateItem: (payload, id) => {
       RequestClient.confirmRequest({
        body: payload,
        id: id,
        ct: "json",
        tenant: clientName,
        option: 'updateItem',
        infoModal:{
          title:controlsPage?.lblSuccessfulProcess?.value,
          description:controlsPage?.lblTheInformationHBeenRegisteredCorrectly?.value
          },
          op:"b"
      })
    }
  };

  const actionOnChange = (data) => {
    const value = (function () {
      switch (data?.id) {
        // case "idCaptcha":
        //   return data?.key;
        case "idDynamicKeyType":
        case "clientLanguages":
          return data?.selectedItem?.key;
        default:
          return data?.selectedItem;
      }
    })();
    if (formValues.hasOwnProperty(data.id) && formValues[data.id] !== value && value !== undefined) {
      setFormValues(currentValue => ({
        ...currentValue,
        [data.id]: value
      }));
      const fieldsTemp = fieldsForm;
      const fieldsToMap = fieldsTemp.map(f => {
        let fi = f
        if (fi.key === data.id){
          fi = {
          ...fi,
          defaultValu: value,
          defaultValue: value
          }
        }
        return fi;
      })
      setFieldsForm(fieldsToMap)
    }
  };

  return (
    <>
      <ContainerLargeForm
        dataForm={_ => {
        }}
        formTitle={clientSelected ? "Configurar Cliente" : "Nuevo Cliente"}
        Items={fieldsForm}
        closePanel={() => onClosePanel(isEdited)}
        actionOnChange={actionOnChange}
        isDisableOpt={[
          {disable: false, key: "valueDefault"},
          {disable: true, key: "name"},
        ]}
        controlsPage={controlsPage}
        onSubmitEventFormPanel={submitForm}
        itemsComponentInformation={{}}
        defaultSelectedKeys={[]}
        defaultValueInput={[]}
      />
    </>
  );
};


export default PanelClient;
